import React from "react";

const Footer = () => {
  const countriesData = [
    {
      cName: "Canada",
    },
    {
      cName: "USA",
    },
    {
      cName: "Europe",
    },
    {
      cName: "Italy",
    },
    {
      cname: "Spain",
    },
  ];

  const LanguagesData = [
    {
      lName: "Punjabi",
    },
    {
      lName: "Hindi",
    },
    {
      lName: "Urdu",
    },
    {
      lName: "Mandarin",
    },
    {
      lName: "Spainsh",
    },
  ];

  const footerC1 = [
    {
      c1Name: "Who We Are ",
    },
    {
      c1Name: "Blog",
    },
    {
      c1Name: "Work With Us",
    },
    {
      c1Name: "Investor Relation",
    },
    {
      c1Name: "Report Fraud",
    },
    {
      c1Name: "Contact us",
    },
  ];

  const zomaverseData = [
    {
      zname: "Zomato",
    },
    {
      zname: "Blinkit",
    },
    {
      zname: "Feeding India",
    },
    {
      zname: "Hyperpure",
    },
    {
      zname: "Zomaland",
    },
  ];

  const lmData = [
    {
      lm: "Privacy",
    },
    {
      lm: "Security",
    },
    {
      lm: "Terms",
    },
    {
      lm: "SiteMap",
    },
  ];
  return (
    <div>
      <div className="containter-fluid bg-body-tertiary py-4">
        <div className="container row m-auto">
          <div className="col-md-6 text-start">
            <h1
              className="text-start text-black"
              style={{
                fontStyle: "italic",
                fontSize: "2rem",
                fontWeight: "900",
              }}
            >
              zomato
            </h1>
          </div>

          <div className="col-md-6 text-center">
            <div className="btn-group">
              <button
                className="btn btn-outline-secondary btn-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                India
              </button>
              <ul className="dropdown-menu">
                {countriesData.map((data) => {
                  return (
                    <li key={data.cName}>
                      <a className="dropdown-item" href="#">
                        {data.cName}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="btn-group ms-2">
              <button
                className="btn btn-outline-secondary btn-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                English
              </button>
              <ul className="dropdown-menu">
                {LanguagesData.map((data) => {
                  return (
                    <li key={data.lName}>
                      <a className="dropdown-item" href="#">
                        {data.lName}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="container row m-auto mt-4">
          <div className="col-md-3">
            <h6 className="fw-semibold text-black mb-3">ABOUT ZOMATO</h6>
            {footerC1.map((data) => {
              return (
                <p
                  className="text-secondary"
                  style={{ fontSize: "14px", marginBottom: "4px" }}
                  key={data.c1Name}
                >
                  {data.c1Name}
                </p>
              );
            })}
          </div>
          <div className="col-md-3">
            <h6 className="fw-semibold text-black mb-3">ZOMAVERSE</h6>
            {zomaverseData.map((data) => {
              return (
                <p
                  className="text-secondary"
                  style={{ fontSize: "14px", marginBottom: "4px" }}
                  key={data.zname}
                >
                  {data.zname}
                </p>
              );
            })}
          </div>
          <div className="col-md-3">
            <h6 className="fw-semibold text-black mb-3">FOR RESTAURANTS</h6>
            <p
              className="text-secondary"
              style={{ fontSize: "14px", marginBottom: "4px" }}
            >
              Partner With Us
            </p>
            <p
              className="text-secondary"
              style={{ fontSize: "14px", marginBottom: "4px" }}
            >
              Apps For You
            </p>

            <h6 className="fw-semibold text-black mb-3 mt-4">
              FOR ENTERPRISES
            </h6>
            <p
              className="text-secondary"
              style={{ fontSize: "14px", marginBottom: "4px" }}
            >
              Zomato For Work
            </p>
          </div>
          <div className="col-md-3">
            <h6 className="fw-semibold text-black mb-3">LEARN MORE</h6>
            {lmData.map((data) => {
              return (
                <p
                  className="text-secondary"
                  style={{ fontSize: "14px", marginBottom: "4px" }}
                  key={data.lm}
                >
                  {data.lm}
                </p>
              );
            })}
          </div>
        </div>
        <div className="container mt-3">
          <hr />
          <p className="text-secondary" style={{ fontSize: "14px" }}>
            By continuing past this page, you agree to our Terms of Service,
            Cookie Policy, Privacy Policy and Content Policies. All trademarks
            are properties of their respective owners. 2008-2023 © Zomato™ Ltd.
            All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
